/* eslint-disable max-len */
import { COUNTRIES } from 'common/constants';

export const FAQs = {
  [COUNTRIES.INDIA]: [
    {
      eventKey: '1',
      question: 'What is Yodaa?',
      answer:
        'Yodaa is a neo bank designed for teens, that empowers teen users with their own card and smart money app. Yodaa Cards work online and in stores all over India, and the app lets teens spend, set up recurring savings, split bills with friends, and learn about personal finance.\nThe exclusive Yodaa Club is a community of financially empowered teens who will receive access to curated networking and earning opportunities. ✌️',
    },
    {
      eventKey: '2',
      question: 'Who is Yodaa built for?',
      answer:
        'Yodaa is designed for teens aged 13-19. Parents of teens can also sign up and invite their teens to Yodaa. 🧒',
    },
    // {
    //   eventKey: '3',
    //   question: 'Can I sign up for Yodaa without an invite?',
    //   answer:
    //     "Yodaa is currently invite-only. You can request an invite by signing up on the Yodaa App and we'll be in touch very soon to usher you into the exclusive Yodaa Club. 🙌",
    // },
    {
      eventKey: '4',
      question: 'Is my data safe with Yodaa?',
      answer:
        'Absolutely. Yodaa is built by a team with years of experience in banking, and adheres to industry standard data protection and privacy standards. 🔒',
    },
    {
      eventKey: '5',
      question: 'Is Yodaa free?',
      answer: [
        "Starting a Yodaa Basic account and getting a virtual Yodaa Card is completely free and always will be. To enjoy the full Yodaa experience, we recommend getting Yodaa Premium.",
        <br />,
        <br />,
        "On top of everything available in Yodaa Basic, Premium offers a free physical Yodaa Card for in store purchases, the ability to set up recurring savings plans and auto-invest in gold, and unlimited access to Yodaa's learning content.",
      ],
    },
    {
      eventKey: '6',
      question: 'How can I pause my Yodaa subscription?',
      answer:
        'You can pause your subscription at any time from the settings section in the Yodaa app. No questions asked. 😊',
    },
  ],
  [COUNTRIES.SINGAPORE]: [
    {
      eventKey: '1',
      question: 'What is Yodaa?',
      answer:
        'Yodaa is a neo bank designed for teens, that empowers teen users with their own card and smart money app. Yodaa Cards work online and in stores all over India, and the app lets teens spend, set up recurring savings, split bills with friends, and learn about personal finance.\nThe exclusive Yodaa Club is a community of financially empowered teens who will receive access to curated networking and earning opportunities. ✌️',
    },
    {
      eventKey: '2',
      question: 'Who is Yodaa built for?',
      answer:
        'Yodaa is designed for teens aged 13-19. Parents of teens can also sign up and invite their teens to Yodaa. 🧒',
    },
    {
      eventKey: '3',
      question: 'Can I sign up for Yodaa without an invite?',
      answer:
        "Yodaa is currently invite-only. You can request an invite by signing up on the Yodaa App and we'll be in touch very soon to usher you into the exclusive Yodaa Club. 🙌",
    },
    {
      eventKey: '4',
      question: 'Is my data safe with Yodaa?',
      answer:
        'Absolutely. Yodaa is built by a team with years of experience in banking, and adheres to industry standard data protection and privacy standards. 🔒',
    },
    {
      eventKey: '5',
      question: 'Is Yodaa free?',
      answer:
        "No. Yodaa offers a physical card to teen users, besides curated learning opportunities and a robust community. We don't trouble our users with ads or sell your data to make money, and transparently charge a __ SGD subscription fee, billed every month. You can of course test drive Yodaa during our 7 day trial period before committing to a subscription. 👍",
    },
    {
      eventKey: '6',
      question: 'How can I pause my Yodaa subscription?',
      answer:
        'You can pause your subscription at any time from the settings section in the Yodaa app. No questions asked. 😊',
    },
  ],
  [COUNTRIES.MALAYSIA]: [
    {
      eventKey: '1',
      question: 'What is Yodaa?',
      answer:
        'Yodaa is a neo bank designed for teens, that empowers teen users with their own card and smart money app. Yodaa Cards work online and in stores all over India, and the app lets teens spend, set up recurring savings, split bills with friends, and learn about personal finance.\nThe exclusive Yodaa Club is a community of financially empowered teens who will receive access to curated networking and earning opportunities. ✌️',
    },
    {
      eventKey: '2',
      question: 'Who is Yodaa built for?',
      answer:
        'Yodaa is designed for teens aged 13-19. Parents of teens can also sign up and invite their teens to Yodaa. 🧒',
    },
    {
      eventKey: '3',
      question: 'Can I sign up for Yodaa without an invite?',
      answer:
        "Yodaa is currently invite-only. You can request an invite by signing up on the Yodaa App and we'll be in touch very soon to usher you into the exclusive Yodaa Club. 🙌",
    },
    {
      eventKey: '4',
      question: 'Is my data safe with Yodaa?',
      answer:
        'Absolutely. Yodaa is built by a team with years of experience in banking, and adheres to industry standard data protection and privacy standards. 🔒',
    },
    {
      eventKey: '5',
      question: 'Is Yodaa free?',
      answer:
        "No. Yodaa offers a physical card to teen users, besides curated learning opportunities and a robust community. We don't trouble our users with ads or sell your data to make money, and transparently charge a __ MYR subscription fee, billed every month. You can of course test drive Yodaa during our 7 day trial period before committing to a subscription. 👍",
    },
    {
      eventKey: '6',
      question: 'How can I pause my Yodaa subscription?',
      answer:
        'You can pause your subscription at any time from the settings section in the Yodaa app. No questions asked. 😊',
    },
  ],
  [COUNTRIES.THAILAND]: [
    {
      eventKey: '1',
      question: 'What is Yodaa?',
      answer:
        'Yodaa is a neo bank designed for teens, that empowers teen users with their own card and smart money app. Yodaa Cards work online and in stores all over India, and the app lets teens spend, set up recurring savings, split bills with friends, and learn about personal finance.\nThe exclusive Yodaa Club is a community of financially empowered teens who will receive access to curated networking and earning opportunities. ✌️',
    },
    {
      eventKey: '2',
      question: 'Who is Yodaa built for?',
      answer:
        'Yodaa is designed for teens aged 13-19. Parents of teens can also sign up and invite their teens to Yodaa. 🧒',
    },
    {
      eventKey: '3',
      question: 'Can I sign up for Yodaa without an invite?',
      answer:
        "Yodaa is currently invite-only. You can request an invite by signing up on the Yodaa App and we'll be in touch very soon to usher you into the exclusive Yodaa Club. 🙌",
    },
    {
      eventKey: '4',
      question: 'Is my data safe with Yodaa?',
      answer:
        'Absolutely. Yodaa is built by a team with years of experience in banking, and adheres to industry standard data protection and privacy standards. 🔒',
    },
    {
      eventKey: '5',
      question: 'Is Yodaa free?',
      answer:
        "No. Yodaa offers a physical card to teen users, besides curated learning opportunities and a robust community. We don't trouble our users with ads or sell your data to make money, and transparently charge a __ THB subscription fee, billed every month. You can of course test drive Yodaa during our 7 day trial period before committing to a subscription. 👍",
    },
    {
      eventKey: '6',
      question: 'How can I pause my Yodaa subscription?',
      answer:
        'You can pause your subscription at any time from the settings section in the Yodaa app. No questions asked. 😊',
    },
  ],
};
